<script setup>
import { computed } from 'vue';
import { useCoin2CoreStore } from '../stores/coin2core';

// Brand guideline (DaLand v1.1, "The Mark"): the white mark is only reproduced
// reversed on Purple Deep - never directly on a light or busy background. The DB
// branding record ships the white variant, so every placement gets the badge.
const props = defineProps({
  // 'badge' = full reversed panel for page headers; 'compact' = small nav chip
  variant: { type: String, default: 'badge' }
});

const store = useCoin2CoreStore();

const logoSrc = computed(() =>
  store.portalBranding.logo ? 'data:image/png;base64,' + store.portalBranding.logo : null
);
</script>

<template>
<div v-if="logoSrc" id="homeLogo" class="logo-badge" :class="variant">
  <img :src="logoSrc" class="logo" :alt="store.creditUnionName || 'Coin2Core'" />
</div>
</template>

<style scoped>
.logo-badge {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--hero-panel-bg, #241344);
  overflow: hidden;
}

/* Soft radial blue glow, top-right - mirrors the site's hero badge */
.logo-badge::after {
  content: '';
  position: absolute;
  right: -25%;
  top: -60%;
  width: 80%;
  height: 170%;
  border-radius: 50%;
  background: var(--hero-panel-glow, radial-gradient(circle, rgba(30, 143, 255, 0.3), transparent 70%));
  pointer-events: none;
}

.logo-badge.badge {
  border-radius: 1.125rem;
  padding: 1.25rem 1.75rem;
  box-shadow: var(--shadow-primary-lg, 0 10px 25px -5px rgba(36, 19, 68, 0.2));
}

.logo-badge.compact {
  border-radius: 0.625rem;
  padding: 0.25rem 0.625rem;
}

.logo {
  position: relative;
  z-index: 1;
  display: block;
  width: auto;
  object-fit: contain;
}

.logo-badge.badge .logo {
  height: 4.5rem;
  max-width: 100%;
}

.logo-badge.compact .logo {
  height: 2.25rem;
}
</style>
